import React from 'react'
import "../../components/Toolbar/Toolbar.js"
import "./Home.css"

import ReadAloud from '../../components/ReadAloud/ReadAloud';
import "katex/dist/katex.min.css";

const Home = ({ fontSize }) => {
    return (
        <div className='page'>
                  
            <div className="lines1" style={{position: "absolute", top: "-6vh", left: 0}}>
            <svg width="9vw" height="auto" viewBox="0 0 191 401" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M190 278.5H98V399.5H-58" stroke="var(--text-secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M-18 1.5H33V248H189.5" stroke="var(--text-secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div className="lines2" style={{position: "absolute", top: "13vh", right: "0vh"}}>
            <svg width="80vw" height="auto" viewBox="0 0 1288 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 24.9024V1H831.638V71H1473" stroke="var(--text-secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </div>

            <div className="line" style={{position: "absolute", top: "80vh", right: "0vw"}}>
            <svg width="8vw" height="auto" viewBox="0 0 124 338" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 337H52.4463V1H124" stroke="var(--text-secondary)" stroke-width="2"/>
            </svg>
            </div>

            <div className="line" style={{position: "absolute", top: "130vh", left: "-2vw"}}>
            <svg width="18vw" height="auto" viewBox="0 0 318 1065" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M318 1.5H88V530.5M88 530.5H186M88 530.5V1063.5H-130.5" stroke="var(--text-secondary)" stroke-width="2"/>
            </svg>
            </div>

            <div className="line" style={{position: "absolute", top: "200vh", right: "0vw"}}>
            <svg width="8vw" height="auto" viewBox="0 0 124 338" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 337H52.4463V1H124" stroke="var(--text-secondary)" stroke-width="2"/>
            </svg>
            </div>

            <h1 className="page-title" style={{fontSize: `${60+fontSize}px`}}>Pinene Express</h1>

            <ReadAloud>
            <h2 style={{fontSize: `${35+fontSize}px`, color: "var(--logo)", marginBottom: "2vh"}}>The greener cannabis alternative</h2>
            
            <div className="home-description" style={{display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "10vh"}}>
                <div className="home-desc-text">
                    <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
                    Cannabis is a general term for products derived from the cannabis plant. 
                    </div>
                    <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
                    In 2018, the Canadian government decriminalized recreational cannabis.
                    </div>
                    <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
                    Since then, both demand and the cannabis industry have grown at unimaginable rates. Cannabis farms, processing plants, and dispensaries are becoming more commonplace.
                    </div>
                    <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
                    Unfortunately, cultivating cannabis is a wasteful and inefficient process.
                    </div>
                </div>
                <img width="50%" alt="home" src="https://static.igem.wiki/teams/4393/wiki/frame-29.png" />
            </div>
            <br />
            <br />

            <div className="home-icons" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-evenly"}}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "30vw", width: "40vw", zIndex: 1}}>
                <img width="80%" alt="home" src="https://static.igem.wiki/teams/4393/wiki/group-78-1.png" />
                </div>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "30vw"}}>
                <img width="70%" style={{marginBottom: "11vh"}} alt="home" src="https://static.igem.wiki/teams/4393/wiki/group-151.png" />
                </div>
            </div>
            <div className="home-comments" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-evenly",  marginBottom: "15vh"}}>
                <div className="page-text" style={{fontSize: `${18+fontSize}px`, marginBottom: "2vh", width: "30vw", textAlign: "center"}}>
                Outdoor cultivation takes up significant land and consumes large amounts of water.
                </div>
                <div className="page-text" style={{fontSize: `${18+fontSize}px`, marginBottom: "2vh", width: "30vw", textAlign: "center", marginLeft: "11vw"}}>
                Indoor cultivation is energy-intensive and emits significant amounts of greenhouse gas as a result.
                </div>
            </div>

            <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
            As the popularity of cannabis continues to rise in Canada and the United States, our current infrastructure and cultivation practices aren’t a sustainable way to meet projected demands.
            </div>
            <br />
            <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "15vh"}}>
            Given how much success we have experienced with using synthetic biology to manufacture plant-based drugs, could we achieve the same for the main ingredients of cannabis?
            </div>
            </ReadAloud>

            <ReadAloud>
            <h2 style={{fontSize: `${35+fontSize}px`, color: "var(--logo)"}}>Our Solution</h2>
            <div className="home-description" style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                <div className="home-desc-text">
                    <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
                    Pinene Express uses bioengineered yeast to produce the main cannabinoids and select terpenes found in the cannabis plant.
                    </div>
                    <div className="page-text" style={{fontSize: `${20+fontSize}px`, marginBottom: "2vh"}}>
                    Pure compounds are extracted from yeast and shipped to various manufacturers where they can mix compounds as needed to mimic cannabis plant extract, eliminating the need for cultivation and post-processing altogether.
                    </div>
                </div>
                <img width="40%" alt="home" src="https://static.igem.wiki/teams/4393/wiki/frame-28-1.png" />
            </div>
            <div style={{marginBottom: "10vh"}}>
                <a className="but" href="/waterloo/description">Learn More</a>
            </div>
            
            </ReadAloud>
        </div>
    )
}

export default Home